module.exports = __webpack_public_path__ + "img/icon-insurance.b87740cd.svg";